export default __webpack_public_path__ + "static/media/Map_Aspen_Phase_I.0b55a660.jpg";